//core
import React, { useState, useEffect } from 'react';
// import logo from './logo.svg';
import axios from 'axios';
// //material-ui
// import Dialog from "@material-ui/core/Dialog";
// import DialogTitle from "@material-ui/core/DialogTitle";
// import DialogContent from "@material-ui/core/DialogContent";
// import DialogActions from "@material-ui/core/DialogActions";
// import Slide from "@material-ui/core/Slide";
//dashboard-pro
import Card from "./components/Card/Card.jsx";
import CardHeader from "./components/Card/CardHeader.jsx";
import CardBody from "./components/Card/CardBody.jsx";
import Snackbar from "./components/Snackbar/Snackbar.jsx";
import Wizard from "components/Wizard/Wizard.jsx";
import { checkOrgnizationCode } from './global/utils'
// import Button from "components/CustomButtons/Button.jsx";
// import GridContainer from "components/Grid/GridContainer.jsx";
// import GridItem from "components/Grid/GridItem.jsx";

// E:\git\register_web\src\components\Snackbar\Snackbar.jsx
// import CardFooter from "./components/Card/CardFooter.jsx";
// import { hexToRgb,infoColor,blackColor,whiteColor } from "assets/jss/material-dashboard-pro-react.jsx";
//components
import { ReactTableDefaults } from 'react-table'
//buiness
// import { GlobalProvider,GlobalConsumer } from './global/Global.context.js';
// import { GlobalContext } from 'global/Global.context.js';
import CommonHttp from 'global/CommonHttp';
import ConfirmModal from 'global/ConfirmModal';
import HeaderLogo from 'global/HeaderLogo';
import Contactperson from 'steps/Contactperson'
import Legalperson from 'steps/Legalperson'
import Certificate from 'steps/Certificate'
import CompanyProtocol from 'steps/CompanyProtocol'
import PlatformProtocol from 'steps/PlatformProtocol'
import Result from 'steps/Result'
import ProtocolModal from 'global/ProtocolModal';
import {
  isFullAngle, companyContractPersonRequiredFields,
  companyLegalPersonRequiredFields,
  companyErrorFields, requestTry
} from 'global/utils.js';
// import { object } from 'prop-types';

//保存成功的id：c074eca9031f4fe6ade3498847f96007
Object.assign(ReactTableDefaults, {
  noDataText: "暂无数据", nextText: '下一页', previousText: '上一页',
  showPageJump: false, showPagination: false, pageText: "", ofText: "", rowsText: "行",
  // renderPageJump: ({ onChange, value, onBlur, onKeyPress, inputType, pageJumpText }) => <span></span>,
  renderPageSizeOptions: ({ pageSize, pageSizeOptions, rowsSelectorText, onPageSizeChange, rowsText, }) => <span></span>,
  renderTotalPagesCount: page => <span></span>, renderCurrentPage: page => <span></span>
})
let detailObj = {};
let certificateList = {//整一个用于与后台交互
  list: []
};
let categoryIds = '';//这个用于保存证书的时候传递给后台
function App() {
  //个人字段
  const [personalInfo, setpersonalInfo] = useState({
    mobile: "", verificationCode: "",
    realName: "", sex: 1, password: "", comfirmPassword: "", supplierName: "", orgnizationCode: "", picVerificationCode: "",
    email: "", qq: "",
  })
  /** 1 可用 */
  const [companyNameVerification, setcompanyNameVerification] = useState(1);
  //公司字段
  const [companyInfo, setcompanyInfo] = useState({
    supplierName: '', property: '',
    registerCapital: '', typeName: '', orgnizationCode: '', supplierClassName: '',
    regNumber: '', businesslicense: '', supplierClass: '', companysendareaids: '',
    phone: '', fax: '', companyareaid: '', address: '', zipCode: '', website: '',
    contactPerson: '', mobile: '', taxpayerType: '', bankNumber: '', companysendarea: '',
    taxType: '', openBankAddress: '', unionPayNumber: '', representative: '', companyarea: '',
    representativeTel: '', idCard: '', idcardurl: '', idcardfront: '', idcardback: '', primarybusiness: '',
    introduction: '', laterContent: '', currency: 'b705a72a9e971d6e9f9b89ca6ab34440', openBankName: '', email: '',
    listedCompany: '', countryId: '', buildTime: '', industryId: '', taxTypeId: '',
    claEconomicId: '', accountTypeId: '', accountName: '', currencyId: 'b705a72a9e971d6e9f9b89ca6ab34440',
    invoiceAddr: '', invoicePhone: '', invoicePayNumber: "", invoiceBankName: '',
    invoiceBankNumber: ''
  })
  // 选项数组
  const [optObj, setOptObj] = useState({
    companyList: [],
    industryList: [],
    currencyList: [],
    enconomicList: [],
    classificationList: [],
    natureList: [],
    categoryList: [],
    transactionList: [],
  })
  useEffect(() => {
    if (optObj.companyList.length > 0) {
      setcompanyInfo(prevState => {
        return { ...prevState, countryId: optObj.companyList.filter((o) => o.name === '中国')[0].id }
      })
    }

  }, [optObj])
  const [certificateInfo, setcertificateInfo] = useState([]);
  //选择合作意向的列表
  const [demanderList, setdemanderList] = useState([])
  //等待审核的列表
  const [resultList, setresultList] = useState([])
  //当前页码
  // const [currentStep, setcurrentStep] = useState(0)
  const [platformProtocolChecked, setplatformProtocolChecked] = useState(false);

  const [snackbarObj, setsnackbarObj] = useState({
    open: false, color: 'danger',
    msg: '默认提示'
  });
  const [btnVisible, setBtnVisible] = useState(false)
  const [openConfirm, setopenConfirm] = useState(false);//控制确认框的显示与否
  //来一个变量，用于用户判断
  let alreadyConfirm = false;
  const [intentionList, setIntentionList] = useState([]);
  const [modalOpen, setmodalOpen] = useState(false)
  const [modalContent, setmodalContent] = useState('')
  useEffect(() => {
    // CommonHttp.get('/register/currentStep').then(res => {//获取当前在哪一步
    CommonHttp.get('/register/currentStep').then(res => {//获取当前在哪一步
      // CommonHttp.get('/register/shared-base-data/basic/v1/currentStep').then(res => {//获取当前在哪一步
      //默认第一步？
      let result;
      if (res.currentStep) {
        result = res;
      } else {
        result = { currentStep: 1 };
      }
      // const result = res ? res : {currentStep:1};
      if (result.currentStep !== 1) {
        let targetLink = document.getElementById(res.currentStep - 1 + 'Link');
        targetLink && targetLink.click();
      }
      //将已有的id都保存起来
      detailObj.supplierId = result.supplierId;
      detailObj.userId = result.userId;
      detailObj.companyId = result.companyId;//仿佛没啥用
    }, err => {
      openSnackbar(err);
    })

    return () => {
      localStorage.clear();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    // 国籍
    requestTry(CommonHttp.get('/shared-base-data/basic/v1/dictionaries/nationality/list')).then((res) => {
      const tempList = res;
      setOptObj(prevState => {
        return { ...prevState, companyList: tempList }
      })
    })
    // 币种
    requestTry(CommonHttp.get('/shared-base-data/basic/v1/dictionaries/currency/list')).then((res) => {
      const tempList = res;
      setOptObj(prevState => {
        return { ...prevState, currencyList: tempList }
      })
    })
    // 账户类型
    requestTry(CommonHttp.get('/shared-base-data/basic/v1/dictionaries/classification/list')).then((res) => {
      const tempList = res;
      setOptObj(prevState => {
        return { ...prevState, classificationList: tempList }
      })
    })
    // 行业类型
    requestTry(CommonHttp.get('/shared-base-data/basic/v1/dictionaries/industry/list')).then((res) => {
      const tempList = res;
      setOptObj(prevState => {
        return { ...prevState, industryList: tempList }
      })
    })
    // 经济类型
    requestTry(CommonHttp.get('/shared-base-data/basic/v1/dictionaries/economic/list')).then((res) => {
      const tempList = res;
      setOptObj(prevState => {
        return { ...prevState, enconomicList: tempList }
      })
    })
    // 单位类型
    requestTry(CommonHttp.get('/shared-base-data/basic/v1/dictionaries/nature/list')).then((res) => {
      const tempList = res;
      setOptObj(prevState => {
        return { ...prevState, natureList: tempList }
      })
    })
    // 税种
    requestTry(CommonHttp.get('/shared-base-data/basic/v1/dictionaries/category/list')).then((res) => {
      const tempList = res;
      setOptObj(prevState => {
        return { ...prevState, categoryList: tempList }
      })
    })
    // 纳税人类型
    requestTry(CommonHttp.get('/shared-base-data/basic/v1/dictionaries/transaction/list')).then((res) => {
      const tempList = res;
      setOptObj(prevState => {
        return { ...prevState, transactionList: tempList }
      })
    })
  }, [])
  const checkPlatformProtocol = prop => {
    let result = !platformProtocolChecked;
    setplatformProtocolChecked(result);
  }

  const getCertificate = (classIds, ids) => {
    categoryIds = ids;
    if (!categoryIds) {//ids为空，表示没有选择任何的内容
      //不请求任何数据
      //表格内容置空
      setcertificateInfo([]);
      //与后台交互的数据置空
      certificateList.list = [];
    } else {
      // CommonHttp.get('/register/certificate/list?userId=' + detailObj.userId).then(res => {//页面展示哪些证书
      // let curUserId = detailObj.userId ? detailObj.userId : localStorage.gsetItem('register_userId');
      // CommonHttp.get('/register/certificate/list?userId=' + curUserId).then(res => {//页面展示哪些证书
      CommonHttp.get('/register/certificate/list_new?categoryIds=' + classIds).then(res => {//页面展示哪些证书
        // CommonHttp.get('/register/certificate/list?userId=4DA3C57E36E3B61186BE1A48AAF86FBCABD04AACE9AF3CC3').then(res => {//页面展示哪些证书
        certificateList.list = [];//首次请求置空
        res.cartoryInfos.map(k => {
          k.gategories.map(i => {
            if (i.infos && i.infos.length > 0) {//已经上传过，回显操作，并且要修改上传的对象
              let url = i.infos.map(c => {
                return c.attachurl;
              })
              let params = {
                certType: i.id,
                certificateName: i.name,
                required: i.required,
                id: "",
                url: url.join()
              }
              certificateList.list.push(params);
            } else if (i.required) {//如果必传，又没东西的，来一个空对象，判空的时候用
              certificateList.list.push({
                certType: i.id,
                certificateName: i.name,
                required: i.required,
                id: "",
                url: ''
              });
            }
            return i
          })
          return k
        })
        setcertificateInfo(res);
      }, err => {
        openSnackbar(err);
      })
    }
  }

  const enterStep = step => {
    // 0:协议 1:企业联系人 2:公司法人信息 3:证书上传 4:选择意向单位 5:审核结果
    if (step === 0 || step === 1) {//第一步协议，第二步个人信息，都不存在回显
      return false;
    }
    if (step === 2) {//公司法人信息
      let curUserId = detailObj.userId ? detailObj.userId : localStorage.getItem('register_userId');
      // CommonHttp.get('/register/companyInfo?userId=' + detailObj.userId).then(res => {//获取已经保存的公司信息
      CommonHttp.get('/register/companyInfo?userId=' + curUserId).then(res => {//获取已经保存的公司信息
        // CommonHttp.get('/register/companyInfo?userId=50E46204F870FDA84E917CB1B398BC754BBD8DF7883FEC31').then(res => {//获取已经保存的公司信息
        res = res ? res : {};
        res.idcardurl = res.idcardurl ? res.idcardurl : '';
        res.idcardfront = res.idcardurl.split(',,,')[0];
        res.idcardback = res.idcardurl.split(',,,')[1];
        setcompanyInfo(prevState => {
          return { ...prevState, ...res }
        })
      }, err => {
        openSnackbar(err);
      })
    } else if (step === 3) {
      //证书上传进入之后不再开始请求
      // getCertificate();
    } else if (step === 4) {//选择意向单位初始化
      CommonHttp.get('/register/demander').then(res => {//页面展示可选择的需方
        res.map(prop => {
          prop.checked = true;
          return prop;
        })
        setdemanderList(res);
      }, err => {
        openSnackbar(err);
      })
    } else if (step === 5) {//审核结果
      // CommonHttp.get('/register/examines??supplierId=' + detailObj.supplierId).then(res => {//页面展示审核结果
      let curSupplierId = detailObj.supplierId ? detailObj.supplierId : localStorage.getItem('register_supplierId');
      CommonHttp.get('/register/examines?supplierId=' + curSupplierId).then(res => {//页面展示审核结果
        setresultList(res);
      }, err => {
        openSnackbar(err);
      })
    }
  }

  const confirm = key => {
    setopenConfirm(false);
    alreadyConfirm = true;
    let btn = document.getElementById('nextButton');
    btn.click();
    // nextCheck(3,null,true);
  }

  const nextCheck = async (step, callback, confirm) => {
    let result;
    if (step > 2) {//证书上传、选择意向单位、审核结果
      if (step === 3) {//证书上传
        if (certificateList.list.length === 0) {
          //没有数据，就说明没有选择任何的供货类别
          return openSnackbar('请选择对应的供货类别，并上传相关资质证书', 'warning');
        }
        for (let m = 0; m < certificateList.list.length; m++) {//正常情况
          if (certificateList.list[m].required && !certificateList.list[m].url) {
            return openSnackbar('还有必传项未上传', 'warning');
          }
        }
        //用户点击上传之后，会有个弹窗给确认
        //确认之后alreadyConfirm为true，逻辑才能继续往下走
        if (!alreadyConfirm) {
          //这里先校验后台给的必上传项目
          setopenConfirm(true);
        } else {
          let params = {
            categoryIds,
            supplierId: (detailObj.supplierId ? detailObj.supplierId : localStorage.getItem('register_supplierId'))
          }
          params = { ...certificateList, ...params };
          result = await axios.post(
            '/shared-base-data/basic/v1/register/certificate/save',
            params,
            { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
          );
          if (result.status !== 200) {
            openSnackbar(result.data ? result.data : '出错了');
          }
          return result.status === 200;
        }
      } else if (step === 4) {//选择意向单位
        let checkedId = [];
        demanderList.map(prop => {
          if (prop.checked) {
            checkedId.push(prop.id);
          }
          return prop;
        })
        if (checkedId.length === 0) {
          return openSnackbar('至少选择一个意向单位', 'warning');
        }
        let params = {
          ids: checkedId.join(','),
          // supplierId:'e20b738c368844f0af63930d5a02bbcb'
          supplierId: (detailObj.supplierId ? detailObj.supplierId : localStorage.getItem('register_supplierId'))
        }
        if (params.ids.includes('15')) {// 判断选择了建造云
          const isNext = await axios.get(`/shared-base-data/basic/v1/register/demander/screening?supplierId=${params.supplierId}`).then(async (res) => {
            if (!res.data.status) {
              setBtnVisible(true)
              if (intentionList.length > 0) {
                result = await axios.post(
                  '/shared-base-data/basic/v1/register/demander/save',
                  {
                    provePicture: intentionList.length > 0 ? intentionList.join(',') : intentionList[0],
                    ...params
                  },
                  { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
                );
                if (result.status !== 200) {
                  setmodalOpen(true)
                  setmodalContent(result.data ? result.data : '出错了')
                }
                return true
              }
              else {
                // setBtnVisible(false)
              }
              setmodalOpen(true)
              setmodalContent(`您本次选择“善建云”为意向合作单位，根据四川华西集团供应商管理办法规定，监测到您公司人员与华西集团人员重名，请上传${res.data.persons.join(",") || ''}身份证件信息或其他个人信息证明证件`, 'warning')
            } else {// res.data.status为false 需要改变按钮状态
              result = await axios.post(
                '/shared-base-data/basic/v1/register/demander/save',
                { provePicture: '', ...params },
                { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
              );
              if (result.status !== 200) {
                setmodalOpen(true)
                setmodalContent(result.data ? result.data : '出错了')
              }
              return result.status === 200;
            }
          }).catch((err) => {
            setBtnVisible(false)
            setmodalOpen(true)
            setmodalContent('服务异常，请稍后再试')
          })

          return isNext

        } else {
          result = await axios.post(
            '/shared-base-data/basic/v1/register/demander/save',
            params,
            { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
          );
          if (result.status !== 200) {
            openSnackbar(result.data ? result.data : '出错了');
          }
          return result.status === 200;
        }

      }
      // else{//审核结果

      // }
    } else {//认证协议、企业联系人、公司法人
      if (step === 0) {//认证协议
        if (!platformProtocolChecked) {
          openSnackbar('必须同意认证协议', 'warning');
        }
        result = await platformProtocolChecked;
        return result;
      } else if (step === 1) {//企业联系人
        if (companyNameVerification < 1) {
          //供应商名称不可用
          const msg = companyNameVerification === -1 ? '公司名称中有括号的必须为全角' : '公司名称不可用，请重新输入'
          return openSnackbar(msg, 'warning');
        }
        // 判断必填项
        // if (!personalInfo.mobile || !personalInfo.verificationCode ||
        //   !personalInfo.realName || !personalInfo.password || !personalInfo.email ||
        //   !personalInfo.comfirmPassword || !personalInfo.orgnizationCode || !personalInfo.supplierName) {//有未添项
        //   return openSnackbar('还有必填项未填写', 'warning');
        // }
        for (let i = 0, len = companyContractPersonRequiredFields.length; i < len; i++) {
          const key = companyContractPersonRequiredFields[i];
          if (!personalInfo[key]) {
            const { name, event } = companyErrorFields[key]
            const fullErrMsg = `${event === 'input' ? '请输入' : "请选择"}${name}`
            return openSnackbar(fullErrMsg, 'warning');
          }
        }
        if (personalInfo.password !== personalInfo.comfirmPassword) {
          return openSnackbar('两次输入的密码不同', 'warning');
        }
        try {
          const checkOrgnizationCodeRes = await checkOrgnizationCode(personalInfo.orgnizationCode, personalInfo.supplierName, openSnackbar)
          if (!checkOrgnizationCodeRes) return
        } catch (error) {
          return
        }
        result = await axios.post(
          '/shared-base-data/basic/v1/register/userSave',
          personalInfo,
          { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
        );
        if (result.status === 200) {
          detailObj.userId = result.data;//保存联系人信息后获取userId
          localStorage.setItem('register_userId', result.data)//将联系人信息同时保存在localstorage中
          openSnackbar('保存成功', 'success');
        } else {
          openSnackbar(result.data ? result.data : '出错了');
        }
        return result.status === 200;
        // result = await true;
        // return result;
      } else {//公司法人联系人
        let params = Object.assign({}, companyInfo);
        params.registerUserId = (detailObj.userId ? detailObj.userId : localStorage.getItem('register_userId'));
        for (let i = 0, len = companyLegalPersonRequiredFields.length; i < len; i++) {
          const key = companyLegalPersonRequiredFields[i];
          if (!params[key] && params[key] !== 0 && params[key] !== false) {
            const { name, event } = companyErrorFields[key]
            const fullErrMsg = `${event === 'input' ? '请输入' : "请选择"}${name}`
            return openSnackbar(fullErrMsg, 'warning');
          }
        }
        let tempArr = [];
        if (!(params.idcardfront && params.idcardback)) {
          return openSnackbar('身份证未完整上传', 'warning');
        }
        if ((params.unionPayNumber + '').length !== 12) {
          return openSnackbar('请输入正确的12位联行号', 'warning');
        }
        if ((params.invoicePayNumber + '').length !== 12) {
          return openSnackbar('请输入正确的12位发票开户银行联行号', 'warning');
        }
        tempArr.push(params.idcardfront);
        tempArr.push(params.idcardback);
        params.idcardurl = tempArr.join(',,,');
        delete params.idcardback;
        delete params.idcardfront;
        params.registerUserId = (detailObj.userId ? detailObj.userId : localStorage.getItem('register_userId'));
        // 保存公司信息
        result = await axios.post(
          '/shared-base-data/basic/v1/register/companySave',
          params, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
        );
        if (result.status !== 200) {
          openSnackbar(result.data ? result.data : '出错了');
        } else {
          detailObj.supplierId = result.data;//保存公司信息后获取supplierId
          // 拿到supplierId之后就保存供应商来源
          const sourceStr = window.location.search;
          const sourceArr = sourceStr.split('=')
          if (sourceStr && sourceStr.length > 0) {
            const sourceCode = sourceArr[sourceArr.length - 1];
            // 如果有search这个字段，就保存一下供应商来源
            CommonHttp.post(`/register/supplierFrom?supplierId=${detailObj.supplierId}&code=${sourceCode}`);
          }
          localStorage.setItem('register_supplierId', result.data);//supplierId也保留一份在localStorage中
          openSnackbar('保存成功', 'success');
        }
        return result.status === 200;
      }
    }
  }

  //uploadSuccess证书上传成功的方法
  const uploadSuccess = (index, row, url, del) => {
    //上传成功与删除都在这里处理
    //因为需求变动，这里要增加选择供货类别的功能
    // console.log(index,row,url,del);
    let listIndex;
    if (del) {//这里处理删除的逻辑
      listIndex = certificateList.list.findIndex(el => {
        return el.certType === row.id;
      })
      let listUrl = certificateList.list[listIndex].url;
      listUrl = listUrl.split(',');
      let urlIndex = listUrl.findIndex(i => {
        return i === url;
      });
      listUrl.splice(urlIndex, 1);
      certificateList.list[listIndex].url = listUrl.join();

      //处理表格显示的数据
      let tempObj = Object.assign({}, certificateInfo);
      tempObj.cartoryInfos[index].gategories.map(prop => {
        if (prop.id === row.id) {
          //这里再循环里面的infos
          let count;
          for (let v = 0; v < prop.infos.length; v++) {
            if (prop.infos[v].attachurl === url) {
              count = v;
              break;
            }
          }
          prop.infos.splice(count, 1);
          // prop.uploaded = listUrl.join();
        }
        return prop;
      })

      setcertificateInfo(tempObj);
    } else {//这里处理上传成功的逻辑
      //处理后台所需数据的逻辑
      listIndex = certificateList.list.findIndex(el => {
        return el.certType === row.id;
      })
      if (listIndex !== -1) {//说明之前已经有了
        // certificateList.list[listIndex].url = certificateList.list[listIndex].url + ',' + url;
        certificateList.list[listIndex].url = url;
      } else {//之前还没有，创建一个对象推入需要与后台交互的数据
        let params = {
          certType: row.id,
          certificateName: row.name,
          required: row.required,
          id: "",
          url: url
        }
        certificateList.list.push(params);
      }

      // 再处理当前需要显示的数据
      let tempObj = Object.assign({}, certificateInfo);
      tempObj.cartoryInfos[index].gategories.map(prop => {
        if (prop.id === row.id) {
          if (!prop.infos) {
            prop.infos = [];
            prop.infos.push({
              attachurl: url
            })
          } else {
            if (prop.infos[0]) {
              prop.infos[0].attachurl = url;
            } else {
              prop.infos.push({ attachurl: url });
            }
          }
        }
        return prop;
      })
      setcertificateInfo(tempObj);
    }
  }

  // 上传
  const uploadSuccessFile = (url, del) => {
    if (del) {//这里处理删除的逻辑
      const temp = intentionList.filter((i) => i !== url)
      setIntentionList(temp)
    } else {
      let tempArr = [...intentionList];
      tempArr.push(url)
      setIntentionList(tempArr)
    }

  }
  const checkSupplierName = (value) => {
    if (!isFullAngle(value)) {
      setcompanyNameVerification(-1);
      openSnackbar('公司名称中有括号的必须为全角', 'warning');
    } else {
      CommonHttp.get(`/register/verification/companyName?companyName=${value}`).then(res => {
        if (res) {
          //公司名称可用
          setcompanyNameVerification(1);
          openSnackbar('公司名称可用', 'success');
        } else {
          setcompanyNameVerification(0);
          openSnackbar('公司名称不可用，请重新输入', 'warning');
        }
      }, () => {
        //这里要不要处理？
      })
    }

  }
  //个人修改的方法
  const changeContact = (key, value) => {
    const obj = {};
    obj[key] = value;
    setpersonalInfo(prevState => {
      return { ...prevState, ...obj }
    });
    // if (key === 'supplierName' && value) {
    //   //输入公司名称的时候，要校验一下是否重复
    //   CommonHttp.get(`/register/verification/companyName?companyName=${value}`).then(res => {
    //     if (res) {
    //       //公司名称可用
    //       setcompanyNameVerification(true);
    //       openSnackbar('公司名称可用', 'success');
    //     } else {
    //       setcompanyNameVerification(false);
    //       openSnackbar('公司名称不可用，请重新输入', 'warning');
    //     }
    //   }, () => {
    //     //这里要不要处理？
    //   })
    // }
    //当取值公司名称、组织机构代码、联系电话、邮箱时
    //公司那边也改一哈哈
    //邮箱只同步下发，公司信息页面不展示
    const synStr = ['orgnizationCode', 'supplierName', 'mobile', 'email'];
    if (synStr.includes(key)) {
      setcompanyInfo(prevState => {
        return { ...prevState, ...obj }
      });
    }
    if (key === 'realName') {
      const nameObj = {
        contactPerson: value
      }
      setcompanyInfo(prevState => {
        return { ...prevState, ...nameObj }
      });
    }
  }

  //公司修改的方法
  const changeLegal = (key, value, name) => {
    let obj = {};
    if (key === 'companysendareaids') {//供货区域
      obj[key] = value;
      obj.companysendarea = name;
      setcompanyInfo(prevState => {
        return { ...prevState, ...obj }
      })
    } else if (key === 'registerCapital') {
      //校验最多四位小数
      if (value && !/^\d+(\.\d{1,4})?$/.test(value)) {
        return openSnackbar('注册资金最多保留四位小数', 'warning');
      }
      obj[key] = value;
      setcompanyInfo(prevState => {
        return { ...prevState, ...obj }
      })
    } else if (key === 'supplierClass') {//供货类别
      obj[key] = value;
      obj.supplierClassName = name;
      setcompanyInfo(prevState => {
        return { ...prevState, ...obj }
      })
    } else if (key === 'companyareaid') {//公司所在地
      obj[key] = value;
      obj.companyarea = name;
      setcompanyInfo(prevState => {
        return { ...prevState, ...obj }
      })
    } else if (key === 'bankNumber' || key === 'orgnizationCode' || key === 'unionPayNumber' || key === 'invoicePayNumber'
      || key === 'invoiceBankNumber') {
      const strArr = value.match(key === 'orgnizationCode' ? /[\u4e00-\u9fa5a-zA-Z0-9]/g : /[0-9]/g)
      obj[key] = strArr ? strArr.join('') : '';
      if (key === 'unionPayNumber' || key === 'invoicePayNumber') {
        if ((obj[key] + '').length > 12) {
          return false
        }
        if ((obj[key] + '').length !== 12) {
          const text = key === 'invoicePayNumber' ? '请输入正确的12位发票开户银行联行号' : '请输入正确的12位联行号'
          openSnackbar(text, 'warning');
        }
      }
      setcompanyInfo(prevState => {
        return { ...prevState, ...obj }
      })
    } else {//其他
      obj[key] = value;
      setcompanyInfo(prevState => {
        return { ...prevState, ...obj }
      })
    }
  }

  const checkCompany = id => {
    let tempData = [];
    tempData = tempData.concat(demanderList);
    // let tempData = Object.assign({},demanderList);
    tempData.map(prop => {
      if (prop.id === id) {
        prop.checked = !prop.checked;
      }
      return prop;
    })
    setdemanderList(tempData);
  }

  const closeSnackbar = () => {
    let obj = { open: false };
    setsnackbarObj(prevState => {
      return { ...prevState, ...obj }
    })
  }

  const openSnackbar = (msg, color) => {
    let obj = { open: true, msg: msg };
    obj.color = color ? color : 'danger';
    setsnackbarObj(prevState => {
      return { ...prevState, ...obj }
    })
    setTimeout(() => {
      closeSnackbar()
    }, 3000)
  }

  return (
    // <GlobalProvider>
    // <GlobalConsumer>
    <Card className='main-card' style={{ marginTop: '12px', marginBottom: '0px' }}>
      <CardHeader style={{ minHeight: '80px' }}>
        <HeaderLogo />
      </CardHeader>
      <CardBody>
        <Wizard title="" color="info" subtitle=""
          currentStep={0}
          nextButtonText="下一步"
          previousButtonText="上一步"
          finishButtonText="完成注册"
          nextCheck={nextCheck}
          enterStep={enterStep}
          steps={[
            {
              stepName: "认证协议", stepComponent: PlatformProtocol,
              stepId: "platformprotocol", formObj: platformProtocolChecked,
              changeFun: checkPlatformProtocol
            },
            {
              stepName: "企业联系人信息", stepComponent: Contactperson,
              stepId: "contactperson", formObj: personalInfo,
              changeFun: changeContact, openSnackbar: openSnackbar,
              checkSupplierName: checkSupplierName
            },
            {
              stepName: "公司及法人信息", stepComponent: Legalperson,
              stepId: "legalperson", formObj: companyInfo,
              optObj: optObj,
              changeFun: changeLegal, openSnackbar: openSnackbar
            },
            {
              stepName: "证书上传", stepComponent: Certificate,
              stepId: "certificate", formObj: certificateInfo,
              openSnackbar: openSnackbar, changeFun: uploadSuccess,
              closeSnackbar: closeSnackbar,
              getCertificate: getCertificate
            },
            {
              stepName: "选择意向单位", stepComponent: CompanyProtocol,
              stepId: "protocol", formObj: demanderList, btnVisible: btnVisible,
              changeFun: checkCompany,
              uploadFile: uploadSuccessFile,
              intentionList: intentionList,
            },
            {
              stepName: "审核结果", stepComponent: Result,
              stepId: "result", formObj: resultList
            }
          ]}
        />
      </CardBody>
      <Snackbar place="bl" color={snackbarObj.color} message={snackbarObj.msg} open={snackbarObj.open} close
        closeNotification={closeSnackbar} />
      <ConfirmModal open={openConfirm} close={() => setopenConfirm(false)} confirm={confirm} />
      {/* <CardFooter>
            <Button color='info' onClick={() => setCurrentStep(2)}>试试</Button>
          </CardFooter> */}
      <ProtocolModal open={modalOpen} content={modalContent}
        close={() => { setmodalOpen(false) }} />
    </Card>
    // </GlobalConsumer>
    // </GlobalProvider>

  );
}

export default App;
